import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from 'src/app/modules/warehouse/modules/product/interfaces/product';


@Component({
  selector: 'add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.css']
})

export class AddItemComponent {

  /**
   * Die Produkte die zur Auswahl stehen
   */
  public products: Product[];

  /**
   * Das Formular für eine Bestellposition
   *
   * @var FormGroup
   */
  public itemForm: FormGroup;

  /**
   * Eigenschaft um anzugeben ob das Select mit den Varianten angezeigt werden soll
   *
   * @var boolean
   */
  public showVariants = false;

  constructor(
    public activeModal: NgbActiveModal
  ) {
    this.itemForm = this.createForm();
  }

  /**
   * Erstellt das Formular zum hinzufügen von neuen Positionen
   *
   * @returns FormGroup
   */
  public createForm = () => {
    return new FormGroup({
      IdProduct: new FormControl(),
      Quantity: new FormControl()
    });
  }

  /**
   * Setzt die Produkte in der Klasse
   *
   * @param products
   */
  public setProducts = (products: Product[]) => {
    this.products = products;
  }

  /**
   * Funktion zum schließen des Modals
   */
  public closeModal = () => {
    this.activeModal.close();
  }

  /**
   * Schließt das Modal und übermittelt das neue Item an das Eltern-Component
   */
  public addItem = () => {
    const newItem = this.itemForm.value;
    newItem.Product = this.products.find(item => {
      return item.Id === newItem.IdProduct;
    });
    this.activeModal.close(newItem);
  }

  /**
   * Setzt die Varianten für das Select und blendet es ein
   *
   * @param event
   */
  public setVariants = (event) => {
    const idProduct = event.target.value;
    const tempProduct = this.products.find(item => {
      return (item.Id === idProduct);
    });

    if (tempProduct !== undefined) {
      if (tempProduct.Variants.length > 0) {
        this.showVariants = true;
      }
    }

  }

}
